import * as React from "react";
import styled from "styled-components";

export interface HeaderProps {
  title: string;
  logo: string;
  message: string;
}

const WelcomeHeader = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const EveIcon = styled.img`
  filter: invert(1);
`;

export default class Header extends React.Component<HeaderProps> {
  render() {
    const { title, logo } = this.props;

    return (
      <WelcomeHeader>
        <EveIcon width="90" height="90" src={logo} alt={title} title={title} />
        {/*<h1 className="ms-fontSize-su ms-fontWeight-light ms-fontColor-neutralPrimary">{message}</h1>*/}
      </WelcomeHeader>
    );
  }
}
